var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{staticClass:"eden-alert",attrs:{"type":_vm.type,"closable":false}},[_c('i',{class:['eden-icon-info-circle mr-2', _vm.type]}),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }